<ng-container *transloco="let t">
  <main
    class="suppliers-page-component"
    [class.mobile]="(lessThan$ | async)?.sm"
    [class.xs]="(lessThan$ | async)?.xs">
    <div class="wrapper scroll" id="mainAppScroll">
      <div class="content">
        <span class="fixed-space-32" aria-hidden="true"></span>
        <article class="content-wrapper popsy-card text-gray-05">
          <section class="head pink-back">
            <div class="border-container">
              <img
                src="/assets/images/border-column.svg"
                [alt]="t('featured_banner_title')"
                class="border-column" />
              <ul class="cards-list row-list">
                <li class="info-card circle-card">
                  <popsy-icon-logo-color class="popsy-icon"></popsy-icon-logo-color>
                </li>
              </ul>
            </div>
            <section class="ticket-head red-back">
              <div class="heading-1 green-box">
                <h1>
                  The world’s leading online marketplace for refurbished electronics
                </h1>
              </div>
            </section>
            <!-- Picture -->
            <div class="image-fit-wrapper">
              <img
                src="/assets/images/cluster_phone.webp"
                [alt]="t('featured_banner_title')" />
            </div>
          </section>

          <div class="column-set">
            <section class="column red-back">
              <span class="fixed-space-24"></span>

              <div class="heading-1">
                <p class="description text-gray-light">
                  Explosive growth, unlike any other platform
                </p>
              </div>
              <ul class="cards-list item-list two-col mobile-column text-gray-light">
                <li class="info-card text-gray-light">
                  <popsy-icon-pin class="illustration icon white-stroke"></popsy-icon-pin>
                  <span class="fixed-space-8"></span>
                  <div class="flex flex-col align-start">
                    <h3>2020</h3>
                    <span class="fixed-space-8"></span>
                    <p class="description bold">Founded in New York</p>
                  </div>
                </li>

                <li class="info-card">
                  <popsy-icon-globe
                    class="illustration icon fill-gray-light"></popsy-icon-globe>
                  <span class="fixed-space-8"></span>
                  <div class="flex flex-col align-start">
                    <h3>10+</h3>
                    <span class="fixed-space-8"></span>
                    <p class="description bold">Countries</p>
                  </div>
                </li>
                <li class="info-card">
                  <popsy-icon-stats
                    class="illustration icon fill-gray-light"></popsy-icon-stats>
                  <span class="fixed-space-8"></span>
                  <div class="flex flex-col align-start">
                    <h3>+85%</h3>
                    <span class="fixed-space-8"></span>
                    <p class="description bold">YoY GMV Growth</p>
                  </div>
                </li>
                <li class="info-card">
                  <popsy-icon-percent
                    class="illustration icon fill-gray-light"></popsy-icon-percent>
                  <span class="fixed-space-8"></span>
                  <div class="flex flex-col align-start">
                    <h3>90%</h3>
                    <span class="fixed-space-8"></span>
                    <p class="description bold">Cross-Border Sales</p>
                  </div>
                </li>
                <li class="info-card">
                  <popsy-icon-visit
                    class="illustration icon fill-gray-light"></popsy-icon-visit>
                  <span class="fixed-space-8"></span>
                  <div class="flex flex-col align-start">
                    <h3>300K</h3>
                    <span class="fixed-space-8"></span>
                    <p class="description bold">Monthly Visits</p>
                  </div>
                </li>
                <li class="info-card">
                  <popsy-icon-shipping-box
                    class="illustration icon white-stroke"></popsy-icon-shipping-box>
                  <span class="fixed-space-8"></span>
                  <div class="flex flex-col align-start">
                    <h3>$420</h3>
                    <span class="fixed-space-8"></span>
                    <p class="description bold">Avg. Order Value</p>
                  </div>
                </li>
              </ul>

              <span class="fixed-space-48"></span>

              <div class="heading-1 green-box">
                <h1>Our partners are central to everything we do</h1>
              </div>

              <span class="fixed-space-24"></span>

              <ul class="cards-list single-col text-gray-light flex flex-col">
                <li class="info-card">
                  <h1>62%</h1>
                  <span class="fixed-space-24"></span>
                  <p class="description bold">
                    Share of customers buying Refurbished for the first time
                  </p>
                </li>
                <li class="info-card">
                  <h1>13:1</h1>
                  <span class="fixed-space-24"></span>
                  <p class="description bold">
                    Ratio of sellers per Popsy Account Manager
                  </p>
                </li>
              </ul>
              <span class="fixed-space-24"></span>
            </section>

            <div>
              <section>
                <div class="heading-1 red-box"><h1>How it works</h1></div>

                <span class="fixed-space-64"></span>

                <div class="flex justify-center align-center">
                  <img
                    src="/assets/images/graphic.png"
                    class="graphic-img"
                    [alt]="t('featured_banner_title')" />
                </div>
                <!--  <ul class="cards-list row-list">
              <li class="info-card circle-card">
                <h1>1</h1>
                <span class="fixed-space-8"></span>
                <p class="description">Upload your stock on Popsy</p>
              </li>

              <li class="info-card circle-card">
                <h1>2</h1>
                <span class="fixed-space-8"></span>
                <p class="description">Customers buy online</p>
              </li>

              <li class="info-card circle-card">
                <h1>3</h1>
                <span class="fixed-space-8"></span>
                <p class="description">You receive orders</p>
              </li>
              <li class="info-card circle-card">
                <h1>4</h1>
                <span class="fixed-space-8"></span>
                <p class="description">You deliver to the customer</p>
              </li>
              <li class="info-card circle-card">
                <h1>5</h1>
                <span class="fixed-space-8"></span>
                <p class="description">Popsy pays you</p>
              </li>
              <li class="info-card circle-card">
                <h1>6</h1>
                <span class="fixed-space-8"></span>
                <p class="description">
                  Turn over your inventory faster and increase volumes significantly
                </p>
              </li>
            </ul> -->
              </section>

              <section>
                <div class="heading-1 red-box">
                  <h1>We've received significant press coverage</h1>
                </div>
                <span class="fixed-space-64"></span>

                <div class="feed-grid">
                  <div class="item">
                    <span>{{ t('text_feedback_forbes') }}</span>
                    <span class="fixed-space-16" aria-hidden="true"></span>

                    <popsy-icon-forbes class="icon fill-gray-01"></popsy-icon-forbes>
                  </div>
                  <div class="item">
                    <span>{{ t('text_feedback_insider') }}</span>
                    <span class="fixed-space-16" aria-hidden="true"></span>

                    <popsy-icon-insider class="icon fill-gray-01"></popsy-icon-insider>
                  </div>
                  <div class="item">
                    <span>{{ t('text_feedback_buzzfeed') }}</span>
                    <span class="fixed-space-16" aria-hidden="true"></span>

                    <popsy-icon-buzzfeed class="icon fill-gray-01"></popsy-icon-buzzfeed>
                  </div>
                </div>
              </section>
            </div>
          </div>

          <section class="red-back">
            <div class="heading-1 green-box">
              <h1>We are building the most trusted platform</h1>
            </div>
            <span class="fixed-space-32" aria-hidden="true"></span>

            <ul class="cards-list mobile-column">
              <li class="info-card review-card">
                <div class="flex align-base justify-center">
                  <popsy-icon-star-filled
                    class="illustration star-icon gold"></popsy-icon-star-filled
                  ><popsy-icon-star-filled
                    class="illustration star-icon gold"></popsy-icon-star-filled
                  ><popsy-icon-star-filled
                    class="illustration star-icon gold"></popsy-icon-star-filled
                  ><popsy-icon-star-filled
                    class="illustration star-icon gold"></popsy-icon-star-filled
                  ><popsy-icon-star-filled
                    class="illustration star-icon gold"></popsy-icon-star-filled>
                </div>
                <span class="fixed-space-8"></span>

                <p class="description text-gray-light">
                  “Simple and efficient...loved Popsy!!! And the 1 year warranty is
                  awesome!”
                </p>
                <span class="fixed-space-16"></span>
                <p class="description text-gray-light">- Josh</p>
              </li>
              <li class="info-card review-card">
                <div class="flex align-base justify-center">
                  <popsy-icon-star-filled
                    class="illustration star-icon gold"></popsy-icon-star-filled
                  ><popsy-icon-star-filled
                    class="illustration star-icon gold"></popsy-icon-star-filled
                  ><popsy-icon-star-filled
                    class="illustration star-icon gold"></popsy-icon-star-filled
                  ><popsy-icon-star-filled
                    class="illustration star-icon gold"></popsy-icon-star-filled
                  ><popsy-icon-star-filled
                    class="illustration star-icon gold"></popsy-icon-star-filled>
                </div>
                <span class="fixed-space-8"></span>

                <p class="description text-gray-light">
                  “Much better experience than any other platform. Hopefully, I won’t get
                  scammed”
                </p>
                <span class="fixed-space-16"></span>

                <p class="description text-gray-light">- Laura</p>
              </li>
              <li class="info-card review-card">
                <div class="flex align-base justify-center">
                  <popsy-icon-star-filled
                    class="illustration star-icon gold"></popsy-icon-star-filled
                  ><popsy-icon-star-filled
                    class="illustration star-icon gold"></popsy-icon-star-filled
                  ><popsy-icon-star-filled
                    class="illustration star-icon gold"></popsy-icon-star-filled
                  ><popsy-icon-star-filled
                    class="illustration star-icon gold"></popsy-icon-star-filled
                  ><popsy-icon-star-filled
                    class="illustration star-icon gold"></popsy-icon-star-filled>
                </div>
                <span class="fixed-space-8"></span>

                <p class="description text-gray-light">
                  “I loved my experience with Popsy. Best price and great customer
                  support!”
                </p>
                <span class="fixed-space-16"></span>

                <p class="description text-gray-light">- Stephen</p>
              </li>
              <li class="info-card review-card">
                <div class="flex align-base justify-center">
                  <popsy-icon-star-filled
                    class="illustration star-icon gold"></popsy-icon-star-filled
                  ><popsy-icon-star-filled
                    class="illustration star-icon gold"></popsy-icon-star-filled
                  ><popsy-icon-star-filled
                    class="illustration star-icon gold"></popsy-icon-star-filled
                  ><popsy-icon-star-filled
                    class="illustration star-icon gold"></popsy-icon-star-filled
                  ><popsy-icon-star-filled
                    class="illustration star-icon gold"></popsy-icon-star-filled>
                </div>
                <span class="fixed-space-8"></span>

                <p class="description text-gray-light">
                  “The only marketplace I trust for refurbished items! Forget Amazon…
                  Stick with Popsy!”
                </p>
                <span class="fixed-space-16"></span>

                <p class="description text-gray-light">- Ashley</p>
              </li>
              <li class="info-card review-card">
                <div class="flex align-base justify-center">
                  <popsy-icon-star-filled
                    class="illustration star-icon gold"></popsy-icon-star-filled
                  ><popsy-icon-star-filled
                    class="illustration star-icon gold"></popsy-icon-star-filled
                  ><popsy-icon-star-filled
                    class="illustration star-icon gold"></popsy-icon-star-filled
                  ><popsy-icon-star-filled
                    class="illustration star-icon gold"></popsy-icon-star-filled
                  ><popsy-icon-star-filled
                    class="illustration star-icon gold"></popsy-icon-star-filled>
                </div>
                <span class="fixed-space-8"></span>

                <p class="description text-gray-light">
                  "Thank you Popsy! I can’t ever imagine paying for a new phone again.
                  Popsy is a trustworthy platform! Great experience and fast delivery!”
                </p>
                <span class="fixed-space-16"></span>

                <p class="description text-gray-light">- Blake</p>
              </li>
              <li class="info-card review-card">
                <div class="flex align-base justify-center">
                  <popsy-icon-star-filled
                    class="illustration star-icon gold"></popsy-icon-star-filled
                  ><popsy-icon-star-filled
                    class="illustration star-icon gold"></popsy-icon-star-filled
                  ><popsy-icon-star-filled
                    class="illustration star-icon gold"></popsy-icon-star-filled
                  ><popsy-icon-star-filled
                    class="illustration star-icon gold"></popsy-icon-star-filled
                  ><popsy-icon-star-filled
                    class="illustration star-icon gold"></popsy-icon-star-filled>
                </div>
                <span class="fixed-space-8"></span>

                <p class="description text-gray-light">
                  “I was skeptical buying refurbished… but with the 1 year warranty I
                  figured I should try it”
                </p>
                <span class="fixed-space-16"></span>

                <p class="description text-gray-light">Asma</p>
              </li>
            </ul>
          </section>

          <section>
            <div class="heading-1 red-box">
              <h1>We offer additional services to scale our partnership</h1>
            </div>

            <span class="fixed-space-64"></span>

            <ul class="cards-list row-list">
              <li class="info-card circle-card">
                <popsy-icon-ok-bag class="icon"></popsy-icon-ok-bag>
                <span class="fixed-space-32"></span>
                <h3>Shipping</h3>
                <span class="fixed-space-16"></span>
                <p class="description bold">Do you need a shipping service?</p>
                <span class="fixed-space-16"></span>
                <p class="description">
                  We can deliver your items for you from your warehouse
                </p>
              </li>

              <li class="info-card circle-card">
                <popsy-icon-fast-truck
                  class="icon fill-gray-light"></popsy-icon-fast-truck>
                <span class="fixed-space-32"></span>
                <h3>Fulfillment</h3>
                <span class="fixed-space-16"></span>
                <p class="description bold">Do you need a fulfillment service?</p>
                <span class="fixed-space-16"></span>
                <p class="description">
                  Ship your product to our warehouse, Popsy delivers to your custumer.
                </p>
              </li>

              <li class="info-card circle-card">
                <popsy-icon-talk class="icon"></popsy-icon-talk>
                <span class="fixed-space-32"></span>
                <h3>Customer Support</h3>

                <span class="fixed-space-16"></span>
                <p class="description">
                  We offer dedicated customer support to answer requests from our
                  customers in any language.
                </p>
              </li>
            </ul>

            <span class="fixed-space-64"></span>

            <div class="heading-1 red-box">
              <h1>Buybox algorithm: Our secret sauce</h1>
            </div>

            <span class="fixed-space-48"></span>

            <ul class="cards-list mobile-column">
              <li class="info-card graph-card">
                <h4>Second Hand Marketplace</h4>
                <span class="fixed-space-32"></span>
                <div>
                  <img
                    src="/assets/images/snapshot_1.webp"
                    [alt]="t('featured_banner_title')" />
                </div>

                <span class="fixed-space-32"></span>
                <p class="description bold">Product ID = Multiple Offers</p>
                <p class="description bold">Poor Customer Experience</p>
              </li>
              <li class="flex flex-row align-center mobile-column">
                <img
                  src="/assets/images/arrow.svg"
                  class="arrow-icon"
                  [alt]="t('featured_banner_title')" />
                <span class="fixed-space-8"></span>
                <h4 class="text-bright p-16">
                  Our proprietary algorithm curates the right offer with the best
                  quality-price ratio
                </h4>
                <img
                  src="/assets/images/arrow.svg"
                  class="arrow-icon"
                  [alt]="t('featured_banner_title')" />
              </li>
              <li class="info-card graph-card">
                <div class="flex flex-column">
                  <popsy-icon-popsy-duo
                    class="illustration popsy-duo"></popsy-icon-popsy-duo>
                </div>
                <span class="fixed-space-32"></span>

                <div>
                  <img
                    src="/assets/images/snapshot_2.webp"
                    [alt]="t('featured_banner_title')" />
                </div>

                <span class="fixed-space-32"></span>
                <p class="description bold">Product ID = 1 Offer</p>
                <p class="description bold">Seamless Experience</p>
              </li>
            </ul>
          </section>

          <section class="red-back contact-form">
            <div class="flex flex-row justify-center align-center">
              <!-- <h1 class="text-gray-light">Contact us</h1> -->
              <div class="flex flex-row justify-center align-center">
                <popsy-icon-mail class="illustration mail"></popsy-icon-mail>
                <p class="description text-gray-light m-0">partner&#64;popsy.app</p>
              </div>
              <span class="fixed-space-64"></span>

              <div class="info-card flex flex-row align-center">
                <popsy-icon-phone-negative
                  class="illustration mail"></popsy-icon-phone-negative>
                <span class="fixed-space-4"></span>

                <div class="flex flex-col align-start">
                  <p class="description text-gray-light m-0">US # +1 (646) 776 0438</p>
                  <span class="fixed-space-8"></span>
                  <p class="description text-gray-light m-0">Saudi # +966 800 891 2028</p>
                  <span class="fixed-space-8"></span>
                  <p class="description text-gray-light m-0">UAE # +971 56 203 3924</p>
                </div>
              </div>
            </div>
            <!-- <span class="fixed-space-32"></span>
            <div class="suppliers-form flex flex-col justify-center align-start">
              <h1 class="text-gray-light">We can contact you</h1>
              <app-suppliers-form class="full-width"></app-suppliers-form>
            </div> -->
          </section>
        </article>
        <span class="fixed-space-32" aria-hidden="true"></span>
        <span
          class="fixed-space-64"
          aria-hidden="true"
          *ngIf="(lessThan$ | async)?.sm"></span>
        <ng-container *ngIf="!(inFullScreenMode$ | async)">
          <app-footer
            class="footer"
            [class.phone]="(lessThan$ | async)?.mobileL"></app-footer>
        </ng-container>
      </div>
    </div>
  </main>
</ng-container>
